import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'form-builder',
    component: Children,

    children: [
      {
        path: 'create',
        name: 'form-builder.create',
        component: () => import('../pages/CreateFormPage.vue')
      }
    ]
  }
];

export default routes;
